<template>
  <div class="w-100 h-100">
    <div class="d-flex flex-row justify-content-between align-items-center px-0">
      <div class="col-3s card px-0 mb-0 application-view-height">
        <div class="card-body">
          <div class="d-flex justify-content-center align-items-center flex-column">
            <div class="image_container w-100">
              <img 
                src="@assets/images/users/avatar-7.jpg" 
                ref="imagePreview"
                class="avatar-xl rounded" 
                alt="shreyu"
              >
              <div class="button_container">
                <b-nav-item-dropdown
                  right
                  variant="black"
                  class="dropdown d-none d-lg-block"
                  no-caret
                >
                  <template v-slot:button-content>
                    <h4 title="Setting" class="my-0 py-0 text-muted">
                      ...
                    </h4>
                  </template>
                  <!-- item-->
                  <b-dropdown-item 
                    href="javascript:void(0);"
                    class="notify-item d-flex justify-content-center align-items-center flex-row"
                    @click="onClickActions('updateCompany', model)"
                  >
                    <i class="uil uil-edit mr-1" />
                    Edit Company
                  </b-dropdown-item>
                  <b-dropdown-item 
                    href="javascript:void(0);"
                    class="notify-item d-flex justify-content-center align-items-center flex-row"
                    @click="onClickActions('onSendLink', model, 'function')"
                  >
                    <i class="uil uil-link-alt mr-1" />
                    Send Link to Company
                  </b-dropdown-item>
                </b-nav-item-dropdown>
              </div>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center my-2 text-center w-100">
              <div class="my-2">
                <h5 class="mt-1 mb-0">{{ model.name }}</h5>
              </div>
              <div class="col-12 text-left mt-2 border-top border-bottom">
                <p 
                  title="email"
                  class="text-muted d-flex justify-content-between align-items-start my-3"
                >
                  <span class="mr-3">Email:</span>
                  <!-- <i class="uil uil-envelope-alt mr-1 d-flex align-items-center justify-content-center" /> -->
                  <span>{{ model.email || 'N/A' }}</span>
                </p>
                <p 
                  title="Complete Address" 
                  class="text-muted my-3 d-flex justify-content-between align-items-start"
                >
                  <span class="mr-3">Address:</span>
                  <!-- <i class="uil uil-location-point mr-1 d-flex align-items-center" /> -->
                  {{ model.complete_address || 'N/A' }}
                </p>
                <p
                  title="Language to Communicate"
                  class="text-muted justify-content-between my-3 d-flex align-items-start"
                >
                  <span class="mr-3">Language:</span>
                  <!-- <i class="uil uil-globe mr-1 d-flex align-items-center" /> -->
                  {{ model.language || 'N/A' }}
                </p>
                <p 
                  title="Job(s)"
                  class="text-muted my-3 d-flex justify-content-between align-items-start"
                >
                  <span class="mr-3">No of Job(s):</span>
                  <!-- <i class="uil uil-briefcase-alt mr-1 d-flex align-items-center" /> -->
                  {{ model.total_jobs || 0 }}
                </p>
                <p
                  title="Number of Employee(s)"
                  class="text-muted justify-content-between my-3 d-flex align-items-start"
                >
                  <!-- <i class="uil uil-user mr-1 d-flex align-items-center" /> -->
                  <span class="mr-3">No of Employee(s):</span>
                  {{ model.number_of_employees || 0 }}
                </p>
                <p
                  title="ATS ID"
                  class="text-muted justify-content-between my-3 d-flex align-items-start"
                >
                  <!-- <i class="uil uil-user mr-1 d-flex align-items-center" /> -->
                  <span class="mr-3">ATS ID:</span>
                  {{ model.ats_id || "N/A" }}
                </p>
              </div>
              <div class="py-2 my-2 text-left">
                <p title="Commission" class="text-muted h5 d-flex align-items-center my-0">
                  <span class="mr-1">Commission:</span>
                  <span class="text-danger">
                    {{ model.fixed && model.rate ? model.rate.$numberDecimal : '' | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2) }}
                    {{ !model.fixed && model.rate ? model.rate.$numberDecimal + '%' : '' }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-tabs class="col-8s application-view-height bg-white" v-model="currentTab">
        <b-tab title="Jobs" active>
          <DataTable
            :company_id="model._id"
            :type.sync="type"
            :noTitle="true"
          />
        </b-tab>
        <b-tab class="bg-white" title="Contact Persons" lazy>
          <div class="row page-title align-items-center">
            <div class="col-md-3 col-xl-6">
              <button class="btn2 btn2-primary btn2-md mr-1 mb-3 ml-3 mb-sm-0" @click="openCreateModal">
                <i class="uil-plus mr-1"></i> {{ $t('job.action.create_record') }}
              </button>
            </div>
          </div>
          <Table
            noTitle
            useEdit
            ref="contact_table"
            :params="{ id: model._id ? model._id : model.id }"
            :fields="fields"
            :action="action"
            @openFormBar="openFormBar"
            @radioClicked="radioClicked"
          />
        </b-tab>
        <b-tab class="bg-white" title="Notes" lazy>
          <div class="col-12 d-flex justify-content-between align-items-center">
            <p class="h6"></p>
            <label class="btn btn-sm btn-primary text-center" @click.prevent="$refs.addNotes.show()">
              Add Note
            </label>
          </div>
          <div class="col-12 pt-1 notes_container">
            <p class="h6">Note(s)</p>
            <div class="col-md-12" v-if="model.notes && model.notes.length">
              <p
                class="mb-4"
                style="word-wrap: break-word;"
                v-for="(note) in model.notes"
                :key="note._id"
                v-html="note.description"
              />
            </div>
            <p class="my-0" v-else>No note(s) available</p>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <Dialog
      is_reset_model
      centered
      title="Create Contact"
      size="xl"
      ref="createCompanyContact"
      yesText="Create"
      noText="Cancel"
      :parameters="{ submitted }"
      :component="createContactComponent"
      @onYes="onCreateContactCompany"
    />
    <Dialog
      autoload
      centered
      title="Update Contact"
      size="xl"
      ref="updateCompanyContact"
      yesText="Update"
      noText="Cancel"
      :parameters="{ rowId: contactPersonId, submitted }"
      :component="editContactComponent"
      @onYes="onUpdateContactCompany"
    />
    <Dialog
      centered
      title="Add Note"
      size="lg"
      yesText="Add"
      noText="Cancel"
      ref="addNotes"
      :buttonDisable="noteCreated"
      :parameters="{ submitted }"
      :component="notesComponent"
      @onYes="handleSubmit"
    />
  </div>
</template>

<script>
import DataTable from '@common/datatable2'
import FormMixin from '@mixins/form'
import Table from '@components/table'
import ContactCreate from './contact_create.vue'
import error from '@utils/error'


export default {
  components: {
    DataTable,
    Table,
    Dialog: () => import('@components/dialogs')
  },
  mixins: [ FormMixin ],
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return {
      model:{
        name: '',
      },
      currentTab: 0,
      onHovered: false,
      submitted: false,
      params: {},
      contactPersonId: '',
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
      type: 'active',
      fields: [
        { 
          key: 'radio',
          label: 'Default'
        },
				{ label: this.$t('candidate.form.first_name.label'), key:"first_name", sortable: true},
				{ label: this.$t('candidate.form.last_name.label'), key:"last_name", sortable: true},
				{ label: this.$t('candidate.form.email.label'), key:"email", sortable: false},
				{ label: this.$t('candidate.form.gender.label'), key:"gender", sortable: false},
        {
          key:'actions',
          label:''
        }
      ],
      action: 'company/getContactPersons'
    }
  },
  computed: {
    rowId() {
      let parameters = this.parameters || {}
      return parameters.rowId
    },
    currency_symbol(){
      var symbol = ""
      if(this.model.currency_id){
        symbol = this.model.currency_id.symbol
      }
      return symbol
    },
    createContactComponent() {
      return ContactCreate
    },
    editContactComponent() {
      return () => import('./contact_edit.vue')
    },
    notesComponent() {
      return () => import('./addNotes.vue')
    },
  },
  methods: {
    onClickActions(ref, model, type = 'modal') {
      this.$emit('onClick', { method: ref, type, data: model })
    },
    onSendLink(val) {
      this.$bvModal.msgBoxConfirm('Please confirm that you want to send link to the company(this will use company email and will be sending a temporary link for company view).', {
        titleHtml: '<i class="uil uil-exclamation-triangle text-warning"></i> Please Confirm Action',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitleHtml: '<i class="uil uil-message"></i> SEND LINK',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          let id = val._id ? val._id : val.id ? val.id : this.rowId
          this.$store.dispatch('company/sendLink', { id })
          .then(res => {
            if(res.data.success){
              this.$bvToast.toast(`Successfully sent to the company!`, {
                title: 'Notification',
                variant:'success'
              })
            }
          })
        }
      })
    },
    findUser() {
      let params = {}
      params.id = this.rowId

      return this.$store.dispatch('company/find', params)
      .then(result => {
        this.model = result.data

        if (result.data.avatar_path) {
          this.$refs.imagePreview.src = result.data.avatar_path
        }
      })
      .catch(err => console.log(err))
    },
    radioClicked(id){
      this.$store.dispatch('company/setCPDefault', { id })
      .then(()=> this.$refs.contact_table.fetchData())
      .catch((err) => this.errorFunction(err))
    },
    openFormBar(val, edit = false) {
      if (edit) {
        this.contactPersonId = val
        this.$refs.updateCompanyContact.show()
      }
    },
    openCreateModal() {
      this.$refs.createCompanyContact.show()
    },
    onCreateContactCompany(val) {
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.company_id = this.model._id ? this.model._id : this.model.id

      return this.$store.dispatch('company/createContactPerson', model)
      .then(result => {
        if (result && result.data) {
          this.$refs.createCompanyContact.hide()
          this.$refs.contact_table.fetchData()
          this.submitted = true
          this.$bvToast.toast(`${result.data.first_name} ${result.data.last_name} successfully added!`, {
            title: "Notification",
            variant: "success" 
          })
        }
      })
      .catch(err => this.errorFunction(err))
    },
    onUpdateContactCompany(val) {
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id
      
      return this.$store.dispatch('company/editContactPerson', model)
      .then(result => {
        if (result && result.data) {
          this.submitted = true
          this.$refs.updateCompanyContact.hide()
          this.$refs.contact_table.fetchData()
          this.$bvToast.toast(`${result.data.first_name} ${result.data.last_name} successfully updated!`, {
            title: "Notification",
            variant: "success"
          })
        }
      })
      .catch(err => this.errorFunction(err))
    },
    errorFunction (err) {
      let error = err.response.data || {}

      if (error.errors) {
        let { errors } = error
        for (let key in errors) {
          this.$bvToast.toast(`${errors[key].message}`, {
            title: "Error!",
            variant: "danger"
          })
        }
      }
      else if (error && error.msg) {
        this.$bvToast.toast(`${error.msg}`, {
          title: "Error!",
          variant: "danger"
        })
      }
      else if (error && error.error) {
        this.$bvToast.toast(`${error.error}`, {
          title: "Error!",
          variant: "danger"
        })
      }
    },
    handleSubmit(val){
      this.noteCreated = true;
      let model = {}
      model.id = this.rowId
      model.note = val && val.note ? val.note : ''
      
      this.$store.dispatch('company/createNote', model)
      .then(res => {
        var data = res.data;
        this.model.notes = data.notes;
        this.submitted = !this.submitted;
        this.noteCreated = false;
        this.$bvToast.toast('Note successfully added!', {
          title: 'Notification',
          variant:'success'
        })
      })
      .catch((err) => {
        this.noteCreated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
  },
  watch: {
    rowId () {
      this.findUser()
    },
    currentTab: function () {
      if (this.currentTab == 1) {
        setTimeout(() => {
          if (this.$refs.contact_table) {
            this.$refs.contact_table.fetchData()
          }
        }, 100)
      }
    },
    'parameters.submitted': function () {
      this.findUser()
    }
  },
  mounted () {
    if (this.rowId) {
      this.findUser()
    }
  }
}
</script>

<style lang="scss">
  @media screen and (min-width: 1200px) {
    .col-3s {
      flex: 0 0 28%;
      max-width: 28%;
      padding-left: 12px;
      padding-right: 12px;
    }
    .col-8s {
      flex: 0 0 70%;
      max-width: 70%;
    }

    .application-view-height {
      height: 74vh;
      overflow-y: auto;
      overflow-x: hidden;
      .nav.nav-tabs {
        background: #e8eaee!important;
      }
    }

    .image_container {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .button_container {
        z-index: 999;
        cursor: pointer;
        position: absolute;
        width: 50px;
        top: 0;
        right: 0;
        display: flex;
        align-items: center!important;
        justify-content: center;
      }
    }

    .tab-content {
      .tabpanel {
        .row {
          .card {
            margin-bottom: 0!important;
          }
        }
      }
    }
  }
</style>